// Helpers
import { to } from '../../../lib/helpers';

// Requests
import { userGetAddressesRequest } from '../../../backend/userRequests';

// Consts
export const USER_GET_ADDRESSES_SUCCESS_RECEIVED =
  '[USER] Get Addresses Success';
export const ADDRESS_TYPES = {
  PP: 'primary',
  ML: 'mailing',
};

export const getAddresses = () => {
  return async dispatch => {
    const [{ response, body }] = await to(dispatch(userGetAddressesRequest()));

    if (!body) return false;
    if (response.status !== 200) return Promise.reject({ response, body });

    dispatch({ type: USER_GET_ADDRESSES_SUCCESS_RECEIVED, payload: body.data });

    return Promise.resolve({ response, body });
  };
};